document.addEventListener("DOMContentLoaded", () => {
  const getSectionParent = (node) => {
    while (true) {
      if (node.parentNode.tagName == "SECTION") {
        return node.parentNode;
      }
      if (node.parentNode.tagName == "BODY") {
        return node;
      }
      node = node.parentNode;
    }
  };

  gsap.registerPlugin(ScrollTrigger);

  const fadeups = document.querySelectorAll(".fade-up");

  fadeups.forEach((fadeup) => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: fadeup,
          start: "top 80%",
          end: "bottom 0%",
        },
      })
      .fromTo(
        fadeup,
        {
          autoAlpha: 0,
          y: 100,
        },
        {
          autoAlpha: 1,
          duration: 0.7,
          ease: "ease",
          y: 0,
        },
      );
  });
  const fadelefts = document.querySelectorAll(".fade-left");

  fadelefts.forEach((fadeleft) => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: fadeleft,
          start: "top 80%",
          end: "bottom 0%",
        },
      })
      .fromTo(
        fadeleft,
        {
          autoAlpha: 0,
          x: 50,
        },
        {
          autoAlpha: 1,
          duration: 0.7,
          ease: "ease",
          x: 0,
        },
      );
  });
  const faderights = document.querySelectorAll(".fade-right");

  faderights.forEach((faderight) => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: faderight,
          start: "top 80%",
          end: "bottom 0%",
        },
      })
      .fromTo(
        faderight,
        {
          autoAlpha: 0,
          x: -50,
        },
        {
          autoAlpha: 1,
          duration: 0.7,
          ease: "ease",
          x: 0,
        },
      );
  });
});

